import React from "react";
import { node } from "prop-types";
import { Icon, ICON_SIZES } from "#library/components/Icon/Icon";
import { Text, TEXT_COLORS, TEXT_TYPES, TEXT_WEIGHTS } from "#library/components/Text/Text";
import star from "#library/assets/icons/jds_starFull.svg";
import styles from "./cardFeedback.module.css";
export var CardFeedback = function CardFeedback(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement(Text, {
    type: TEXT_TYPES.SMALL,
    weight: TEXT_WEIGHTS.BOLD,
    color: TEXT_COLORS.MAIN_COLOR,
    resetSpacing: true,
    className: styles["jds-CardFeedback"]
  }, /*#__PURE__*/React.createElement("span", {
    className: styles["jds-CardFeedback__Text"]
  }, children), /*#__PURE__*/React.createElement(Icon, {
    size: ICON_SIZES.SMALL,
    xlinkHref: "#".concat(star.id)
  }));
};
CardFeedback.propTypes = {
  children: node.isRequired
};